/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CredentialRead
 */
export interface CredentialRead {
  /**
   *
   * @type {number}
   * @memberof CredentialRead
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof CredentialRead
   */
  name?: string | null;
}

/**
 * Check if a given object implements the CredentialRead interface.
 */
export function instanceOfCredentialRead(value: object): value is CredentialRead {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function CredentialReadFromJSON(json: any): CredentialRead {
  return CredentialReadFromJSONTyped(json, false);
}

export function CredentialReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialRead {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function CredentialReadToJSON(value?: Omit<CredentialRead, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
